import type { FlexxiPlanStatus } from "@gaole/shared";
import { Badge } from "../ui";

type BadgeColor = "pink" | "blue" | "green" | "amber" | "gray" | "red";

export function flexxiStatusColor(status: FlexxiPlanStatus): BadgeColor {
  switch (status) {
    case "ACTIVE":
      return "blue";
    case "COMPLETED":
      return "green";
    case "OVERDUE":
      return "amber";
    case "DEFAULTED":
      return "red";
    case "PENDING_DEPOSIT":
      return "pink";
    case "CANCELLED":
      return "gray";
    default: {
      const exhaustive: never = status;
      return exhaustive;
    }
  }
}

export function FlexxiStatusBadge({ status, label }: { status: FlexxiPlanStatus; label: string }) {
  return <Badge color={flexxiStatusColor(status)}>{label}</Badge>;
}

export function FlexxiProgressBar({ percent }: { percent: number }) {
  const clamped = Math.max(0, Math.min(100, percent));
  return (
    <div
      className="h-2.5 w-full overflow-hidden rounded-full bg-white/10"
      role="progressbar"
      aria-valuenow={clamped}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className="h-full rounded-full bg-gradient-to-r from-brand-pink to-brand-blue transition-[width]"
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
}
